import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = () => ({
  container: {
    textAlign: "center",
    direction: "ltr",
  },
  containerInline: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    direction: "ltr",
    whiteSpace: "nowrap",
  },
  title: {
    fontSize: "0.9rem",
    fontWeight: "bold",
    marginBottom: "4px",
    whiteSpace: "nowrap",
    lineHeight: 1.3,
  },
  titleInline: {
    fontSize: "0.85rem",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    lineHeight: 1.2,
    marginBottom: 0,
  },
  countdown: {
    fontSize: "0.85rem",
    fontWeight: "600",
    lineHeight: 1.3,
  },
  countdownInline: {
    fontSize: "0.8rem",
    fontWeight: "600",
    lineHeight: 1.2,
  },
});

class LimitedOfferCountdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeRemaining: this.calculateTimeRemaining(),
    };
    this.timerInterval = null;
  }

  componentDidMount() {
    // Update every minute
    this.timerInterval = setInterval(() => {
      this.setState({ timeRemaining: this.calculateTimeRemaining() });
    }, 60000);
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  calculateTimeRemaining = () => {
    const { expiresAt } = this.props;
    if (!expiresAt) return null;

    const now = new Date().getTime();
    const expireTime = new Date(expiresAt).getTime();
    const diff = expireTime - now;

    if (diff <= 0) {
      return { expired: true };
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds, expired: false };
  };

  formatTime = (time) => {
    const { timeRemaining } = this.state;
    if (!timeRemaining || timeRemaining.expired) {
      return "פג תוקף";
    }

    const { days, hours, minutes } = timeRemaining;
    
    const parts = [];
    
    if (days > 0) {
      parts.push(`${days} ימים`);
    }
    
    if (hours > 0 || days > 0) {
      parts.push(`${hours} שעות`);
    }
    
    parts.push(`${minutes} דקות`);

    return parts.join(" ");
  };

  render() {
    const { classes, inline } = this.props;

    if (inline) {
      return (
        <div className={classes.containerInline}>
          <Typography className={classes.titleInline} variant="body2">
            מבצע לזמן מוגבל!
          </Typography>
          <Typography className={classes.countdownInline} variant="caption">
            {this.formatTime()}
          </Typography>
        </div>
      );
    }

    return (
      <div className={classes.container}>
        <Typography className={classes.title} variant="body2">
          מבצע לזמן מוגבל!
        </Typography>
        <Typography className={classes.countdown} variant="caption">
          {this.formatTime()}
        </Typography>
      </div>
    );
  }
}

LimitedOfferCountdown.propTypes = {
  classes: PropTypes.object.isRequired,
  expiresAt: PropTypes.string.isRequired,
  inline: PropTypes.bool,
};

export default withStyles(styles)(LimitedOfferCountdown);

